<div [innerHTML]="infoMessage | i18next" class="info"></div>
